import jsonApi from '../../utils/jsonApi'
import http from '../../utils/http'

export const fetchDoormen = ({ page, per, sort, params }) =>
  jsonApi
    .findAll('school_doorman', {
      params: {
        'q[s]': 'created_at desc',
        'page[number]': page || 1,
        'page[size]': per || 5,
        include: 'school,doorman',
        ...params
      }
    })
    .then(res => res)

export const removeDoorman = id => {
  http.put(`/school_doormen/${id}/remove_doorman`).then(res => res)
}
